// extracted by mini-css-extract-plugin
export default {"PremierSelectorTitle":"PremierSelectorTitle_PremierSelectorTitle","close":"PremierSelectorTitle_close"};